export default __webpack_public_path__ + "static/how-to-c7123d97435443bd9c8e5e2bcb87c2d1.svg";